export default {
  data() {
    return {};
  },
  methods: {
    /* Only reason we needed a custom sort function is for the Stall Name (otherwise the regular vuetify one is fine)
     * eg we want A2 to be above A12 (in a regular alpha sort A2 sits below A12)
     */
    customBookingsSort(items, index, isDesc) {
      let desc = false;

      if (isDesc[0]) desc = true;

      return items.sort((a, b) => {
        if (index[0] === "name") {
          // sort stall names properly eg, we want A2 to be above A12 (in a regular alpha sort A2 sits below A12)

          let regexAlpha = /[^a-zA-Z]/g;
          let regexNumber = /[^0-9]/g;

          let aA = a.name.replace(regexAlpha, "").toLowerCase(); //a alpha portion
          let bA = b.name.replace(regexAlpha, "").toLowerCase(); //b alpha portion

          if (aA === bA) {
            // if same alpha
            let aN = parseInt(a.name.replace(regexNumber, ""), 10); //a number portion
            let bN = parseInt(b.name.replace(regexNumber, ""), 10); //a number portion

            if (!desc) {
              return aN === bN ? 0 : aN > bN ? 1 : -1;
            } else {
              return aN === bN ? 0 : bN > aN ? 1 : -1;
            }
          } else {
            if (!desc) {
              return aA === bA ? 0 : aA > bA ? 1 : -1;
            } else {
              return aA === bA ? 0 : bA > aA ? 1 : -1;
            }
          }
        } else {
          // replicate regular vuetify sort here

          let aValue = a[index];
          let bValue = b[index];

          if (typeof aValue === "string" || aValue instanceof String)
            aValue = aValue.toLowerCase();

          if (typeof bValue === "string" || bValue instanceof String)
            bValue = bValue.toLowerCase();

          if (!desc) {
            // check if index even exists in a or b
            if (!a[index]) return !b[index] ? 0 : -1;
            if (!b[index]) return 1;

            return aValue === bValue ? 0 : aValue > bValue ? 1 : -1;
          } else {
            // check if index even exists in a or b
            if (!a[index]) return !b[index] ? 0 : 1;
            if (!b[index]) return -1;

            return aValue === bValue ? 0 : bValue > aValue ? 1 : -1;
          }
        }
      });
    }
  }
};
